module.exports = __webpack_public_path__ + "0d1f2c9c4f1bebe7b28235aa95d802b9.png";